import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ConsentsFormService} from "../../../services/consents-form.service";
import {MatTabGroup} from "@angular/material/tabs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-my-children',
  templateUrl: './my-children.component.html',
  styleUrls: ['./my-children.component.scss']
})
export class MyChildrenComponent implements OnInit {
 @Input() currentUser;
 @Input() children;
 @Input() notifications;
 @Input() notificationTitle;
  @ViewChild('tabs', {static: false}) tabs: MatTabGroup;

  constructor(private consentsFormService: ConsentsFormService,
              private router: Router) { }

  ngOnInit(): void {
  }

  childrenDisplayName(child: any) {
    return `${child.firstName} ${child.lastName}`;
  }

  childNotification(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length + child.affirmations.length;
  }

  showNotificationToChild(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length === 0;
  }

  async showConsent(notification: any) {

    const child = this.children[this.tabs.selectedIndex];
    await this.consentsFormService.showConsent(notification, this.currentUser, child);
  }

  async showAnnouncement(announcement: any) {
    await this.router.navigate(['home/announcement'], {queryParams: {id: announcement.id, unique_id: announcement.unique_id}});
  }
}
